const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'amenities',
      column: 1,
      type: 'checkGroup',
      dictionary: 'amenity/group',
      dictionaryListField: 'amenities',
    },
  ],
};

export default fields;
